<template>
  <div>
    <TSpinner v-if="loading" name="llmLoading" :partial-page="true" />
    <CoarseFeedback
      :coarse-feedback="coarseFeedback"
      @submit-coarse-feedback="submitCoarseFeedback"
    />
    <GranularFeedback
      v-if="showGranularFeedback"
      :feedback-reason-options="feedbackReasons"
      :granular-feedback="granularFeedback"
      @submit-granular-feedback="submitGranularFeedback"
    />
    <CustomFeedback
      v-if="showCustomFeedback"
      :custom-feedback-reason="customFeedbackReason"
      :disabled="feedbackScreen === FeedbackScreen.SUBMITTED"
      @submit-custom-feedback="submitCustomFeedback"
    />
    <SubmitConfirmation v-if="showConfirmation" />
  </div>
</template>

<script lang="ts">
import TSpinner from '@thyme/nashville/src/components/spinner/TSpinner.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'
import CoarseFeedback from './Screens/CoarseFeedback/CoarseFeedback.vue'
import CustomFeedback from './Screens/CustomFeedback/CustomFeedback.vue'
import GranularFeedback from './Screens/GranularFeedback/GranularFeedback.vue'
import SubmitConfirmation from './Screens/SubmitConfirmation/SubmitConfirmation.vue'
import { LLM_FEEDBACK_PROPS } from './types'

export default defineComponent({
  components: {
    CoarseFeedback,
    CustomFeedback,
    GranularFeedback,
    SubmitConfirmation,
    TSpinner,
  },
  props: LLM_FEEDBACK_PROPS,
  setup,
})
</script>
